import useSWR, { SWRConfiguration } from 'swr';
import { authenticatedFetcher } from '@/lib/swr';
import type { IDHApiResponse } from '@/types/idh';
import { PP_BASE_URL } from '@/lib/env';

interface UseGetStudentIdhInfoOptions {
  enabled?: boolean;
  swrOptions?: SWRConfiguration;
}

export async function fetchStudentIdhInfo(studentId: string): Promise<IDHApiResponse | null> {
  const baseUrl = PP_BASE_URL?.replace(/\/$/, '');
  if (!studentId || !baseUrl) return null;
  return await authenticatedFetcher(`${baseUrl}/students/${encodeURIComponent(studentId)}/info`);
}

export function useGetStudentIdhInfo(studentId?: string | null, options?: UseGetStudentIdhInfoOptions) {
  const enabled = options?.enabled ?? true;
  const baseUrl = PP_BASE_URL?.replace(/\/$/, '');
  const key = enabled && studentId && baseUrl ? `${baseUrl}/students/${encodeURIComponent(studentId)}/info` : null;

  const {
    data: idhResponse,
    error,
    isLoading,
    mutate,
  } = useSWR<IDHApiResponse>(key, authenticatedFetcher, {
    revalidateOnMount: true,
    revalidateOnFocus: false,
    dedupingInterval: 5000,
    shouldRetryOnError: (err: any) => err?.status !== 404,
    ...options?.swrOptions,
  });

  return {
    swrKey: key,
    idhResponse,
    idhData: idhResponse?.data ?? null,
    statusId: idhResponse?.data?.statusId ?? null,
    isLoading,
    error,
    mutate,
  };
}
